import { axiosClient } from "../api/axiosClient";

export type PasskeyCredential = {
  id: string;
  nickname: string | null;
  deviceType: string | null;
  transports: string[];
  createdAt: string;
  lastUsedAt: string | null;
};

type RegistrationResponseJSON = Record<string, unknown>;
type AuthenticationResponseJSON = Record<string, unknown>;
type PublicKeyCredentialCreationOptionsJSON = Record<string, unknown>;
type PublicKeyCredentialRequestOptionsJSON = Record<string, unknown>;

export const passkeyQueryKeys = {
  credentials: ["passkeys"] as const,
};

export const passkeyRepository = {
  async getRegistrationOptions(): Promise<{
    options: PublicKeyCredentialCreationOptionsJSON;
  }> {
    const response = await axiosClient.post(
      "/auth/passkeys/register/options",
      {},
      { withCredentials: true },
    );
    return response.data;
  },

  async verifyRegistration(response: RegistrationResponseJSON): Promise<{
    credential: PasskeyCredential;
  }> {
    const result = await axiosClient.post(
      "/auth/passkeys/register/verify",
      { response },
      { withCredentials: true },
    );
    return result.data;
  },

  async getLoginOptions(email?: string): Promise<{
    options: PublicKeyCredentialRequestOptionsJSON;
  }> {
    const response = await axiosClient.post(
      "/auth/passkeys/login/options",
      email ? { email } : {},
      { withCredentials: true },
    );
    return response.data;
  },

  async verifyLogin(response: AuthenticationResponseJSON) {
    const result = await axiosClient.post(
      "/auth/passkeys/login/verify",
      { response },
      { withCredentials: true },
    );
    return result.data;
  },

  async listCredentials(): Promise<{ credentials: PasskeyCredential[] }> {
    const response = await axiosClient.get("/auth/passkeys", {
      withCredentials: true,
    });
    return response.data;
  },

  async deleteCredential(id: string): Promise<void> {
    await axiosClient.delete(`/auth/passkeys/${id}`, {
      withCredentials: true,
    });
  },

  async renameCredential(
    id: string,
    nickname: string,
  ): Promise<{ credential: PasskeyCredential }> {
    const response = await axiosClient.patch(
      `/auth/passkeys/${id}`,
      { nickname },
      { withCredentials: true },
    );
    return response.data;
  },
};
